// extracted by mini-css-extract-plugin
export default {"pText":"textTooltip_pText__hhL0y"};